// extracted by mini-css-extract-plugin
module.exports = {"header":"Styles_header__3XVkl","body":"Styles_body__3MUl1","image":"Styles_image__31gOp"};